import React, { useState, useEffect, useRef } from 'react';
import { FaRotate } from "react-icons/fa6";


const Captcha = ({ captchaValue, setCaptchaValue, handleCaptchaChange, resetCaptcha, setResetCaptcha }) => {
    const [captchaInput, setCaptchaInput] = useState("");
    const canvasRef = useRef(null);
    const backgroundImage = useRef(new Image());

    useEffect(() => {
        backgroundImage.current.src = 'https://artlogic-res.cloudinary.com/w_1200,c_limit,f_auto,fl_lossy,q_auto/artlogicstorage/gazelli/images/view/006fb757e68812eda0429108860bfc07p/gazell.io-gibson-martelli-captcha-background.png';
        backgroundImage.current.onload = generateCaptcha;
    }, []);

    useEffect(() => {
        if (resetCaptcha) {
            generateCaptcha();
            setCaptchaInput("");
            setResetCaptcha(false);
        }
    }, [resetCaptcha, setResetCaptcha]);

    const handleInputChange = (e) => {
        setCaptchaInput(e.target.value);
        handleCaptchaChange(e.target.value);
    };

    const generateCaptcha = () => {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let captchaText = '';
        for (let i = 0; i < 6; i++) {
            captchaText += chars[Math.floor(Math.random() * chars.length)];
        }
        setCaptchaValue(captchaText);
        drawCaptcha(captchaText);
    };

    const drawCaptcha = (text) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;

        ctx.clearRect(0, 0, width, height);

        // Draw background image to an offscreen canvas
        const offCanvas = document.createElement('canvas');
        offCanvas.width = width;
        offCanvas.height = height;
        const offCtx = offCanvas.getContext('2d');

        offCtx.filter = 'blur(2px)';
        offCtx.drawImage(backgroundImage.current, 0, 0, width, height);

        // Draw blurred background onto main canvas
        ctx.globalAlpha = 0.5;
        ctx.drawImage(offCanvas, 0, 0, width, height);
        ctx.globalAlpha = 1.0;

        // Draw text
        ctx.font = '25px Arial';
        ctx.fillStyle = '#000';
        ctx.fillText(text, 10, 30);
    };


    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

            <div style={{ marginBottom: 5, display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '400px', flexDirection: 'column' }}>
                <div>
                    <canvas ref={canvasRef} width="110" height="40" style={{ border: '1px solid gray', borderRadius: '9px' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <button type='button' aria-label='Generate Captcha' onClick={generateCaptcha} style={{
                        fontSize: '1em', marginRight: '10px', background: '#f2f2f2',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '6px',
                        cursor: 'pointer'
                    }}>
                        < FaRotate style={{ fontSize: '18px' }}/>
                    </button>
                    <input
                        style={{padding:'5px'}}
                        type="text"
                        value={captchaInput}
                        onChange={handleInputChange}
                        placeholder="Enter Captcha"
                    />
                </div>
            </div>
        </div>
    );
};

export default Captcha;
